// extracted by mini-css-extract-plugin
export default {"tableContainer":"Table_tableContainer__CGRez","card":"Table_card__byxbo","table":"Table_table__cZ3zE","tableHeader":"Table_tableHeader__bin-P"};